import useResponsive from "@/hooks/useResponsive";

import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import FAQList from "@/components/FAQs/FAQList";
import FAQMap from "@/components/FAQs/FAQMap";
import { Container } from "@mui/material";

const Faq = () => {
  const isDesktop = useResponsive("up", "md");

  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <FAQList />
      {isDesktop && <FAQMap />}
    </>
  );
};

export default Faq;
